<template>
  <div class="text-center p-5">
    <h1>EJV PEPER</h1>
    <h2>hennig pittig!</h2>
  </div>
</template>

<script>
export default {
  name: 'logoText',
};
</script>
